jQuery(document).ready(function($) {
        // DEBUG: 🚀 Smart Checkout initialized;
    
    // CRITICAL: Restore selected address from localStorage on page load
    var savedAddressId = localStorage.getItem('vitalshop_selected_address');
    if (savedAddressId) {
        
        // Find and check the corresponding radio button
        var $targetRadio = $('input[name="selected_address"][value="' + savedAddressId + '"]');
        if ($targetRadio.length > 0) {
            $targetRadio.prop('checked', true);
        // DEBUG: ✅ Address radio button restored:;
            
            // Trigger the change event to load address data
            $targetRadio.trigger('change');
        } else {
            // Clear invalid saved address
            localStorage.removeItem('vitalshop_selected_address');
        }
    }
    
    // Handle address selection
    $(document).on('change', 'input[name="selected_address"]', function() {
        var selectedValue = $(this).val();
        var $smartSelection = $('.smart-address-selection');
        var $customerDetails = $('.customer-details-section');
        
        
        // CRITICAL: Save selected address to localStorage for persistence
        localStorage.setItem('vitalshop_selected_address', selectedValue);
        
        if (selectedValue === 'new') {
            // Show manual entry form
            $smartSelection.removeClass('active').addClass('manual-entry');
            $customerDetails.find('.billing-fields').show();
            
            // Clear all billing fields (One Address System)
            clearBillingFields();
            
        } else {
            // Load saved address
            $smartSelection.removeClass('manual-entry').addClass('active');
            $customerDetails.find('.billing-fields').hide();
            
            // Load address data via AJAX
            loadSavedAddress(selectedValue);
        }
        
        // Update hidden field
        $('#selected_address_id').val(selectedValue);
        
        // Update visual selection
        updateAddressCardSelection($(this));
        
        // Trigger order review update for shipping calculation
        if (selectedValue !== 'new') {
            triggerOrderReviewUpdate(selectedValue);
        }
    });
    
    // Handle address card clicks (not just radio button)
    $(document).on('click', '.saved-address-card', function(e) {
        if ($(e.target).hasClass('edit-saved-address') || $(e.target).closest('.edit-saved-address').length) {
            return; // Don't select when clicking edit button
        }
        
        var $radio = $(this).find('input[type="radio"]');
        $radio.prop('checked', true).trigger('change');
    });
    
    // Handle edit address button - Open checkout modal
    $(document).on('click', '.edit-saved-address', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var addressId = $(this).data('address-id');
        
        // Open checkout address modal for editing
        openCheckoutAddressModal(addressId);
    });
    
    // Handle new address selection - Open checkout modal
    $(document).on('change', 'input[name="selected_address"][value="new"]', function() {
        if ($(this).is(':checked')) {
            openCheckoutAddressModal();
        }
    });
    
    // Handle manage addresses button - Still redirect for full management
    $(document).on('click', '.manage-addresses', function(e) {
        e.preventDefault();
        window.open(vitalshop_smart_checkout.manage_addresses_url, '_blank');
    });
    
    // Load saved address data
    function loadSavedAddress(addressId) {
        
        // Show loading state
        showLoadingState();
        
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'select_checkout_address',
                nonce: vitalshop_smart_checkout.nonce,
                address_id: addressId
            },
            success: function(response) {
                hideLoadingState();
                
                if (response.success) {
                    var addressData = response.data.address_data;
                    
                    if (addressData) {
                        // Fill billing fields with saved address data (One Address System)
                        fillBillingFields(addressData);
        // DEBUG: ✅ Address data loaded and filled;
                        
                        // Load initial VAT table with the correct address data
                        loadInitialVatTable();
                    } else {
                        
                        // Load initial VAT table with default values
                        loadInitialVatTable();
                    }
                } else {
                    showError(vitalshop_smart_checkout.strings.error);
                }
            },
            error: function(xhr, status, error) {
                hideLoadingState();
                showError(vitalshop_smart_checkout.strings.error);
            }
        });
    }
    
    // Fill billing fields with address data (One Address System)
    function fillBillingFields(addressData) {
        // Map database fields to WooCommerce billing fields
        var fieldMapping = {
            'first_name': 'billing_first_name',
            'last_name': 'billing_last_name',
            'company': 'billing_company',
            'address_1': 'billing_address_1',
            'address_2': 'billing_address_2',
            'city': 'billing_city',
            'postcode': 'billing_postcode',
            'state': 'billing_state',
            'country': 'billing_country',
            'phone': 'billing_phone',
            'email': 'billing_email'
        };
        
        // Always fill email with current user email if logged in
        if (vitalshop_smart_checkout.current_user_email) {
            addressData.email = vitalshop_smart_checkout.current_user_email;
        }
        
        // Fill all mapped fields
        Object.keys(fieldMapping).forEach(function(dbField) {
            var wcField = fieldMapping[dbField];
            var $field = $('#' + wcField);
            
            
            if ($field.length && addressData[dbField]) {
                $field.val(addressData[dbField]);
                
                // Trigger change event for select fields
                if ($field.is('select')) {
                    $field.trigger('change');
                }
                
                // Handle floating labels if they exist
                if ($field.val() && $field.closest('.form-field').length) {
                    $field.closest('.form-field').addClass('has-value');
                }
                
            } else if (!$field.length) {
            } else if (!addressData[dbField]) {
            }
        });
        
        // Trigger WooCommerce update
        $('body').trigger('update_checkout');
        
    }
    
    // Clear all billing fields (One Address System)
    function clearBillingFields() {
        var billingFields = [
            'billing_first_name',
		'billing_last_name',
		'billing_company',
		'billing_address_1',
		'billing_address_2',
		'billing_city',
		'billing_postcode',
		'billing_country',
		'billing_state',
		'billing_phone',
		'billing_email'
        ];
        
        billingFields.forEach(function(field) {
            var $field = $('#' + field);
            if ($field.length) {
                $field.val('');
                
                // Remove floating label state
                if ($field.closest('.form-field').length) {
                    $field.closest('.form-field').removeClass('has-value');
                }
            }
        });
        
    }
    
    // Update visual selection of address cards
    function updateAddressCardSelection($selectedRadio) {
        // Remove selection from all cards
        $('.saved-address-card').removeClass('selected');
        
        // Add selection to current card
        $selectedRadio.closest('.saved-address-card').addClass('selected');
    }
    
    // Show loading state
    function showLoadingState() {
        $('.smart-address-selection').addClass('loading');
        
        if (!$('.address-loading').length) {
            $('.saved-addresses-grid').append(
                '<div class="address-loading">' +
                '<div class="loading-spinner"></div>' +
                '<span>' + vitalshop_smart_checkout.strings.loading + '</span>' +
                '</div>'
            );
        }
    }
    
    // Hide loading state
    function hideLoadingState() {
        $('.smart-address-selection').removeClass('loading');
        $('.address-loading').remove();
    }
    
    // Show error message
    function showError(message) {
        // Remove existing error
        $('.address-error').remove();
        
        // Add error message
        $('.smart-address-selection').prepend(
            '<div class="address-error">' +
            '<span class="error-icon">⚠️</span>' +
            '<span>' + message + '</span>' +
            '</div>'
        );
        
        // Auto-hide after 5 seconds
        setTimeout(function() {
            $('.address-error').fadeOut();
        }, 5000);
    }
    
    // Initialize default address selection on page load
    function initializeDefaultSelection() {
        var $defaultRadio = $('input[name="selected_address"]:checked');
        if ($defaultRadio.length) {
            updateAddressCardSelection($defaultRadio);
            
            // If it's not "new", load the address data
            if ($defaultRadio.val() !== 'new') {
                loadSavedAddress($defaultRadio.val());
            } else {
                // For "new" address, load VAT table with current form data
                loadInitialVatTable();
            }
        }
    }
    
    // Initialize on page load
    initializeDefaultSelection();
    
    /**
     * Load initial VAT table on page load
     */
    function loadInitialVatTable() {
        // Get the current country from the customer data
        var currentCountry = $('select[name="billing_country"], input[name="billing_country"]').val() || 'DE';
        var currentPostcode = $('input[name="billing_postcode"]').val() || '';
        
        
        // Make AJAX call to get VAT table HTML
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'force_wc_session_update',
                nonce: vitalshop_smart_checkout.nonce,
                country: currentCountry,
                first_name: $('input[name="billing_first_name"]').val() || '',
                last_name: $('input[name="billing_last_name"]').val() || '',
                company: $('input[name="billing_company"]').val() || '',
                address_1: $('input[name="billing_address_1"]').val() || '',
                address_2: $('input[name="billing_address_2"]').val() || '',
                city: $('input[name="billing_city"]').val() || '',
                postcode: currentPostcode,
                state: $('select[name="billing_state"], input[name="billing_state"]').val() || '',
                phone: $('input[name="billing_phone"]').val() || '',
                email: vitalshop_smart_checkout.current_user_email
            },
            success: function(response) {
                if (response.success && response.data.vat_table_html) {
        // DEBUG: ✅ Initial VAT table loaded successfully;
                    
                    // Remove any existing VAT tables first
                    $('.vitalshop-modern-order-review .vpe-vat-summary').remove();
                    
                    // Add VAT table after order total
                    var $orderTotalRow = $('.vitalshop-modern-order-review .total-row.order-total-row');
                    if ($orderTotalRow.length > 0) {
                        $orderTotalRow.after(response.data.vat_table_html);
                    }
                } else {
                }
            },
            error: function(xhr, status, error) {
            }
        });
    }
    
    // Handle checkout form submission
    $(document).on('submit', 'form.checkout', function() {
        var selectedAddressId = $('#selected_address_id').val();
    });
    
    // Add custom CSS for loading and error states
    $('<style>')
        .prop('type', 'text/css')
        .html(`
            .address-loading {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;
                padding: 20px;
                background: #f8f9fa;
                border-radius: 8px;
                border: 2px dashed #dee2e6;
                color: #6c757d;
                font-size: 14px;
            }
            
            .loading-spinner {
                width: 20px;
                height: 20px;
                border: 2px solid #dee2e6;
                border-top: 2px solid #007cba;
                border-radius: 50%;
                animation: spin 1s linear infinite;
            }
            
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            
            .address-error {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 12px 16px;
                background: #f8d7da;
                border: 1px solid #f5c6cb;
                border-radius: 6px;
                color: #721c24;
                font-size: 14px;
                margin-bottom: 16px;
            }
            
            .error-icon {
                font-size: 16px;
            }
            
            .smart-address-selection.loading {
                opacity: 0.7;
                pointer-events: none;
            }
        `)
        .appendTo('head');
    
        // DEBUG: ✅ Smart Checkout fully initialized;
    
    // ====== CHECKOUT ADDRESS MODAL FUNCTIONS ======
    
    /**
     * Open checkout address modal for adding/editing
     */
    function openCheckoutAddressModal(addressId = null) {
        var $modal = $('#checkout-address-modal');
        var $form = $('#checkout-address-form');
        var $title = $modal.find('.modal-title');
        
        // Reset form safely
        if ($form.length && $form[0].reset) {
            $form[0].reset();
        }
        $('#checkout_address_id').val('');
        
        if (addressId) {
            // Editing existing address
            $title.text('Adresse bearbeiten');
            loadAddressForEditing(addressId);
        } else {
            // Adding new address
            $title.text('Adresse hinzufügen');
        }
        
        // Show modal
        $modal.fadeIn(300);
        $('body').addClass('modal-open');
        
    }
    
    /**
     * Close checkout address modal
     */
    function closeCheckoutAddressModal() {
        var $modal = $('#checkout-address-modal');
        
        $modal.fadeOut(300);
        $('body').removeClass('modal-open');
        
        // DEBUG: ❌ Checkout address modal closed;
    }
    
    /**
     * Load address data for editing in checkout modal
     */
    function loadAddressForEditing(addressId) {
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'get_checkout_address',
                nonce: vitalshop_smart_checkout.nonce,
                address_id: addressId
            },
            success: function(response) {
                if (response.success && response.data.address) {
                    var address = response.data.address;
                    
                    // Fill form fields
                    $('#checkout_address_id').val(address.id);
                    $('#checkout_address_label').val(address.label);
                    $('#checkout_address_first_name').val(address.first_name);
                    $('#checkout_address_last_name').val(address.last_name);
                    $('#checkout_address_company').val(address.company);
                    $('#checkout_address_1').val(address.address_1);
                    $('#checkout_address_2').val(address.address_2);
                    $('#checkout_address_country').val(address.country);
                    $('#checkout_address_postcode').val(address.postcode);
                    $('#checkout_address_city').val(address.city);
                    $('#checkout_address_state').val(address.state);
                    $('#checkout_address_phone').val(address.phone);
                    $('#checkout_address_is_default').prop('checked', address.is_default == '1');
                    
                } else {
                }
            },
            error: function() {
            }
        });
    }
    
    // Modal event handlers
    $(document).on('click', '#checkout-address-modal .modal-close, #checkout-address-modal .modal-cancel', function() {
        closeCheckoutAddressModal();
    });
    
    $(document).on('click', '#checkout-address-modal .modal-overlay', function() {
        closeCheckoutAddressModal();
    });
    
    // Handle checkout address form submission
    $(document).on('submit', '#checkout-address-form', function(e) {
        e.preventDefault();
        
        var $form = $(this);
        var $saveBtn = $form.find('.modal-save');
        var $btnText = $saveBtn.find('.btn-text');
        var $btnLoading = $saveBtn.find('.btn-loading');
        
        // Show loading state
        $btnText.hide();
        $btnLoading.show();
        $saveBtn.prop('disabled', true);
        
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: $form.serialize() + '&action=save_checkout_address&nonce=' + vitalshop_smart_checkout.nonce,
            success: function(response) {
                if (response.success) {
        // DEBUG: ✅ Address saved successfully;
                    
                    // Close modal
                    closeCheckoutAddressModal();
                    
                    // Reload the page to show updated addresses
                    location.reload();
                } else {
                    alert('Fehler beim Speichern der Adresse: ' + (response.data || 'Unbekannter Fehler'));
                }
            },
            error: function() {
                alert('Fehler beim Speichern der Adresse');
            },
            complete: function() {
                // Reset button state
                $btnText.show();
                $btnLoading.hide();
                $saveBtn.prop('disabled', false);
            }
        });
    });
    
    // ====== DYNAMIC ORDER REVIEW UPDATE ======
    
    /**
     * Trigger order review update when address changes
     */
    function triggerOrderReviewUpdate(addressId) {
        
        // Get the selected address data first
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'get_checkout_address',
                nonce: vitalshop_smart_checkout.nonce,
                address_id: addressId
            },
            success: function(response) {
                if (response.success && response.data.address) {
                    var address = response.data.address;
                    
                    // Update WooCommerce customer data for shipping calculation
                    updateCustomerShippingData(address);
                } else {
                }
            },
            error: function() {
            }
        });
    }
    
    /**
     * Update customer shipping data and trigger checkout update
     */
    function updateCustomerShippingData(address) {
        
        // Show loading state on order review
        var $orderReview = $('.woocommerce-checkout-review-order');
        $orderReview.addClass('updating');
        
        // Update shipping fields in the checkout form (for WooCommerce processing)
        $('#billing_country').val(address.country);
        $('#billing_first_name').val(address.first_name);
        $('#billing_last_name').val(address.last_name);
        $('#billing_company').val(address.company || '');
        $('#billing_address_1').val(address.address_1);
        $('#billing_address_2').val(address.address_2 || '');
        $('#billing_city').val(address.city);
        $('#billing_postcode').val(address.postcode);
        $('#billing_state').val(address.state || '');
        $('#billing_phone').val(address.phone || '');
        
        
        // CRITICAL: Force WooCommerce to recognize the field changes by triggering change events
        // This is essential for shipping cost recalculation
        
        // Clear WooCommerce's internal caches first
        if (typeof wc_checkout_params !== 'undefined') {
        }
        
        // Trigger change events with more emphasis
        $('#billing_country').val(address.country).trigger('change').trigger('blur');
        $('#billing_postcode').val(address.postcode).trigger('change').trigger('blur');
        $('#billing_state').val(address.state || '').trigger('change').trigger('blur');
        
        // Also trigger on any shipping fields that might exist (hidden)
        $('#shipping_country').val(address.country).trigger('change');
        $('#shipping_postcode').val(address.postcode).trigger('change');
        $('#shipping_state').val(address.state || '').trigger('change');
        
        // Log current shipping costs before update
        var $currentShipping = $('.vitalshop-modern-order-review .shipping-row');
        $currentShipping.each(function(i, row) {
        });
        
        // CRITICAL: Force WooCommerce backend session update via AJAX
        // This directly updates WooCommerce's PHP session data
        // DEBUG: 🚀 Forcing WooCommerce backend session update...;
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'force_wc_session_update',
                nonce: vitalshop_smart_checkout.nonce,
                country: address.country,
                first_name: address.first_name,
                last_name: address.last_name,
                company: address.company || '',
                address_1: address.address_1,
                address_2: address.address_2 || '',
                city: address.city,
                postcode: address.postcode,
                state: address.state || '',
                phone: address.phone || '',
                email: vitalshop_smart_checkout.current_user_email
            },
            success: function(response) {
                if (response.success) {
        // DEBUG: ✅ WooCommerce backend session updated:;
                    
                    // CRITICAL: Manually update shipping display with backend data
                    var backendShippingTotal = response.data.shipping_total;
                    var shippingProvider = response.data.shipping_provider || 'DHL';
                    
                    // Update shipping provider label
                    var $shippingLabel = $('.vitalshop-modern-order-review .shipping-row .total-label');
                    
                    $shippingLabel.each(function() {
                        var $el = $(this);
                        var currentText = $el.text().trim();
                        var newLabel = 'Lieferung per ' + shippingProvider;
                        
                        // Preserve "kostenfrei" text if it exists
                        if (currentText.includes('kostenfrei')) {
                            newLabel += ' kostenfrei';
                        }
                        
                        $el.html(newLabel + (currentText.includes('kostenfrei') ? ' <span class="shipping-free-text">kostenfrei</span>' : ''));
                    });
                    
                    // Update shipping price
                    var $shippingValue = $('.vitalshop-modern-order-review .shipping-row .shipping-value');
                    
                    $shippingValue.each(function() {
                        var $el = $(this);
                        var currentText = $el.text().trim();
                        
                        // Fix price format: 12.9 -> 12,90 €
                        var formattedPrice = parseFloat(backendShippingTotal).toFixed(2).replace('.', ',') + ' €';
                        
                        $el.html(formattedPrice);
                    });
                    
                    // Also try to update any .woocommerce-Price-amount inside shipping row
                    $('.vitalshop-modern-order-review .shipping-row .woocommerce-Price-amount').each(function() {
                        var $el = $(this);
                        var currentText = $el.text().trim();
                        var formattedPrice = parseFloat(backendShippingTotal).toFixed(2).replace('.', ',') + ' €';
                        $el.html('<bdi>' + formattedPrice + '</bdi>');
                    });
                    
                    // Update tax totals if provided
                    if (response.data.tax_total) {
                        var formattedTaxTotal = parseFloat(response.data.tax_total).toFixed(2).replace('.', ',') + ' €';
                        
                        // Update tax display elements with correct selectors from review-order.php
                        $('.vitalshop-modern-order-review .total-row.tax-row .total-value.tax-value').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html(formattedTaxTotal);
                        });
                        
                        // Also update any WooCommerce price amounts in tax rows
                        $('.vitalshop-modern-order-review .total-row.tax-row .woocommerce-Price-amount').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html('<bdi>' + formattedTaxTotal + '</bdi>');
                        });
                    }
                    
                    // Update subtotal if provided
                    if (response.data.subtotal) {
                        var formattedSubtotal = parseFloat(response.data.subtotal).toFixed(2).replace('.', ',') + ' €';
                        
                        // Update subtotal with correct selector from review-order.php
                        $('.vitalshop-modern-order-review .total-row.subtotal-row .total-value').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html(formattedSubtotal);
                        });
                    }
                    
                    // Update cart total if provided
                    if (response.data.cart_total) {
                        
                        // Update main total with correct selector from review-order.php
                        $('.vitalshop-modern-order-review .total-row.order-total-row .total-value.total-value-main').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html(response.data.cart_total);
                        });
                        
                        // Fallback: Also try the old selector in case structure changes
                        $('.vitalshop-modern-order-review .total-sum .woocommerce-Price-amount').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html(response.data.cart_total);
                        });
                    }
                    
                    // Update VPE VAT table if provided
                    if (response.data.vat_table_html) {
                        
                        // Remove ALL existing VAT tables first
                        $('.vitalshop-modern-order-review .vpe-vat-summary').remove();
                        
                        
                        // Add the new VAT table
                        var $orderTotalRow = $('.vitalshop-modern-order-review .total-row.order-total-row');
                        if ($orderTotalRow.length > 0) {
                            $orderTotalRow.after(response.data.vat_table_html);
                        }
                    }
                    
                    // Now trigger WooCommerce checkout update to refresh all elements including VAT table
                    setTimeout(function() {
                        $('body').trigger('update_checkout');
                    }, 100);
                } else {
                    // Fallback to frontend-only update
                    setTimeout(function() {
                        $('body').trigger('update_checkout');
                    }, 500);
                }
            },
            error: function(xhr, status, error) {
                // Fallback to frontend-only update
                setTimeout(function() {
                    $('body').trigger('update_checkout');
                }, 500);
            }
        });
        
        // Backup timeout in case updated_checkout event doesn't fire (due to JS errors)
        setTimeout(function() {
            if ($orderReview.hasClass('updating')) {
                $orderReview.removeClass('updating');
            }
        }, 10000); // 10 second timeout
        
        // Listen for checkout update completion
        $(document.body).one('updated_checkout', function() {
            $orderReview.removeClass('updating');
        // DEBUG: ✅ Order review updated successfully;
            
            // Force refresh of shipping display if needed
            setTimeout(function() {
                
                // Debug: Check what order review containers exist
                $('.woocommerce-checkout-review-order').each(function(i, el) {
                });
                
                // Try multiple selectors
                var selectors = [
                    '.vitalshop-modern-order-review .shipping-row',
                    '.woocommerce-checkout-review-order .shipping-row', 
                    '.shipping-row',
                    '.total-row.shipping-row',
                    '[class*="shipping"]'
                ];
                
                selectors.forEach(function(selector) {
                    var $elements = $(selector);
                    if ($elements.length > 0) {
                        $elements.each(function(i, el) {
                        });
                    }
                });
                
                // Check if order review HTML changed completely
                var orderReviewHTML = $('.woocommerce-checkout-review-order').html();
                if (orderReviewHTML) {
                    
                    // Show first 500 chars of HTML to see what template is being used
                }
            }, 100);
            
            // Optional: Show a brief success indicator
            showOrderUpdateSuccess();
        });
    }
    
    /**
     * Show brief success indicator for order update
     */
    function showOrderUpdateSuccess() {
        var $indicator = $('<div class="order-update-success">✅ Versandkosten aktualisiert</div>');
        $indicator.css({
            position: 'fixed',
            top: '20px',
            right: '20px',
            background: '#28a745',
            color: 'white',
            padding: '12px 20px',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '500',
            zIndex: '10000',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            opacity: '0',
            transform: 'translateY(-20px)'
        });
        
        $('body').append($indicator);
        
        // Animate in
        $indicator.animate({
            opacity: 1,
            transform: 'translateY(0)'
        }, 300);
        
        // Auto remove after 3 seconds
        setTimeout(function() {
            $indicator.animate({
                opacity: 0,
                transform: 'translateY(-20px)'
            }, 300, function() {
                $indicator.remove();
            });
        }, 3000);
    }
    
});